import React, {useEffect} from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate} from "react-router-dom"

//Redux imports
import {
    reset,
    setIndividualUser,
    setCorporateUser,
    getSubscriptionStatus,
    getAvatar,
} from "../../Features/Auth/authSlice";

import {getAllReads} from "../../Features/Read/readSlice";
import {getAllWatches} from "../../Features/Watch/watchSlice";
import {getAllLearns} from "../../Features/Learn/learnSlice";
import {getAllFaves} from "../../Features/Favourites/faveSlice";

//components
import Navbar from "../Components/Navbar";
import New from "./New/New"
import ViewingArea from "../ViewingArea/ViewingArea";
import Recommended from "./Recommended/Recommended";
import Landing from "./Landing/Landing";
import Search from "./Search/Search";

import DevLanding from "./Landing/DevLanding";



function Dashboard() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    //redux state
    const { favouritesIsActive } = useSelector(state => state.navBar)
    const { user, isSuccess, message, hasActiveSubscription, avatar_url, id} = useSelector(state => state.auth)
    const { landingIsActive, searchIsActive } = useSelector(state => state.active)

    useEffect(() =>{
        if(!user){
            navigate("/signup")
        }
        if(user){
            dispatch(getSubscriptionStatus(user?.id))
        }
        if(user && user.kipMateCode){
            dispatch(setCorporateUser())
        }
        if(user && !user.kipMateCode){
            dispatch(setIndividualUser())
        }
        if(user && user.id){
            dispatch(getAllWatches());
            dispatch(getAllLearns());
            dispatch(getAllReads());
        }
        return () =>{
            dispatch(reset())
        }
    },[user, dispatch, isSuccess, message, navigate, avatar_url])

    useEffect(() =>{
        dispatch(getAllFaves())
    }, [favouritesIsActive])


    useEffect(() =>{
        dispatch(getAvatar())
    },[user])

    return (
        <>
        {user &&
            <>
            {landingIsActive &&
                <div className="dashboard w-full h-screens bg-purple-dashboard p-px">
                    <div className="container">
                        <DevLanding/>
                    </div>
                </div>
            }

            {(!landingIsActive && !searchIsActive) &&
                <div className="overflow-hidden dashboard w-full h-screen bg-purple-dashboard grid grid-cols-24 grid-rows-12">
                    <Navbar/>
                    <ViewingArea/>
                    <New/>

                    {!favouritesIsActive &&
                        <Recommended/>
                    }
                </div>
            }

                {(!landingIsActive && searchIsActive) &&
                    <Search />
                }


            </>
        }


        </>
    );
}

    export default Dashboard;